
import React, { memo } from "react";
import ReportCard from "../ReportCard";
import { motion, AnimatePresence } from "framer-motion";
import { useInView } from "react-intersection-observer";

interface ReportGridProps {
  reports: any[];
  onReportClick: (report: any) => void;
  onSupportClick: (reportId: number) => void;
}

export const ReportGrid: React.FC<ReportGridProps> = memo(({
  reports,
  onReportClick,
  onSupportClick,
}) => {
  // Configuration pour le chargement progressif des éléments
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  };

  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="grid gap-6 md:grid-cols-2 lg:grid-cols-3"
    >
      <AnimatePresence mode="popLayout">
        {reports.map((report) => (
          <LazyReportCard
            key={report.id}
            report={report}
            onClick={() => onReportClick(report)}
            onSupportClick={() => onSupportClick(report.id)}
          />
        ))}
      </AnimatePresence>
    </motion.div>
  );
});

// Composant avec lazy loading
const LazyReportCard = memo(({ report, onClick, onSupportClick }: { 
  report: any, 
  onClick: () => void, 
  onSupportClick: () => void 
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '200px 0px',
  });

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <motion.div
      ref={ref}
      variants={item}
      layout
      initial="hidden"
      animate={inView ? "show" : "hidden"}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.3 }}
    >
      {inView && (
        <ReportCard 
          {...report} 
          onClick={onClick}
          onSupportClick={onSupportClick}
        />
      )}
    </motion.div>
  );
});

ReportGrid.displayName = 'ReportGrid';
LazyReportCard.displayName = 'LazyReportCard';

export default ReportGrid;
